import React, { Component } from 'react';
import { Table, Row, Button, message, Spin, DatePicker, Icon, Popconfirm, } from 'antd';
import moment from 'moment';
import { dataDefault } from './data';
import Auth from "../../Auth";
import TableText from "../../TableText";
import { numConvert } from "@/method";
import FileSaver from "file-saver";

const { MonthPicker } = DatePicker;
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            update: false,
            hotelName: sessionStorage.getItem('hotelName') || ""
        }
    }

    componentDidMount() {
        this.getDateData(this.state.date);
    }

    computeNum = async (data) => {
        this.setState({ data });
    }
    onChange = (name, value, i) => {
        // 简单粗暴的深拷贝
        let data = JSON.parse(JSON.stringify(this.state.data));
        data[i][name] = value;
        this.computeNum(data);
    }
    getDateData = async (date) => {
        const dataBegin = JSON.stringify(dataDefault);
        let data = JSON.parse(dataBegin);

        fetch(`/urgentInfo?year=${moment(date).format('YYYY')}&month=${moment(date).format('MM')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.data && x.data.data.length > 0) {
                data = x.data.data.sort((a, b) => {
                    return numConvert(a.sort) - numConvert(b.sort)
                });
            }

            this.setState({
                loading: false,
            }, () => {
                this.computeNum(data);
            });

        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let { date, title } = this.state;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("MM");
        let data = this.state.data.map(x => ({ ...x, year, month }));


        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/urgentSave', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (data.some(item => !item.id)) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    onExpoetExcel = () => {
        this.setState({ print: true, loading: true }, () => {
            const name = `Hotel Emergency Report 酒店紧急事件报告 ${moment(this.state.date).format('YYYY-MM')}`;
            const innerHtml = `
              <caption>${name}</caption>
              ${document.getElementById('table').innerHTML.replace(/<table class="">/g, '<table border="1">')}
            `;

            var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
            var blob = new Blob([html], { type: "application/vnd.ms-excel" });
            FileSaver.saveAs(blob, `${name}.xls`);
            this.setState({ print: false, loading: false });
        });
    }
    render() {
        const { data } = this.state;
        const columns = [{
            title: '序号',
            dataIndex: 'sort',
            key: 'sort',
            align: "center",
            width: 50,
            render: (text, record, index) => {
                const props = { text, index, type: 'text', name: "sort", onChange: this.onChange };
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: "紧急事件描述",
            dataIndex: 'describe',
            key: 'describe',
            align: "center",
            width: 300,
            render: (text, record, index) => {
                const title = ['describe'];
                const props = {
                    text, index, type: 'textArea', name: "describe", onChange: this.onChange
                };
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: "风险等级（3级、2级必填）",
            dataIndex: 'level',
            key: 'level',
            align: "center",
            width: 300,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'textArea', name: "level", onChange: this.onChange
                };
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: "处理结果",
            dataIndex: 'result',
            key: 'result',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'textArea', name: "result", onChange: this.onChange
                };
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: "酒店损失金额（元）",
            dataIndex: 'loss',
            key: 'loss',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'inputNumber', name: "loss", onChange: this.onChange
                };
                return (
                    <TableText data={props} />
                )
            }
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table"  >
                    <Row className="title" id="table3_3_4" >
                        <Row>
                            Hotel Emergency Report  酒店紧急事件报告
                        </Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            id="table"
                            pagination={false}
                            className="content"
                            scroll={this.state.print ? {} : { y: 500, }}
                            rowKey={(record, index) => index}
                        />
                    </Row>

                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={() => {
                                this.setState({ print: true }, () => {
                                    this.onExpoetExcel();
                                });
                            }}
                        >导出Excel</Button>
                        <Auth loading={this.state.loading} auth="edit_meetingMinutes">
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Auth>
                    </Row>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/other/urgent/index.js